export default __webpack_public_path__ + "src/images/galleries/0/btn_lan_cn-3c21df.png";